import React, { useRef, useEffect } from 'react';
import './Notification.scss';
import { NotificationIcon } from './NotificationIcon/NotificationIcon';
import { useNotificationVM } from './useNotificationVM';
import { NotificationList } from './NotificationList/NotificationList';

export const Notification: React.FC = () => {
    const { unreadCount, setUnreadCount, isOpen, setIsOpen } = useNotificationVM();
    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [setIsOpen]);

    const openNotificationList = () => {    
        setIsOpen(!isOpen);
    }

    return (
        <div className="notification-wrapper" ref={wrapperRef}>
            <NotificationIcon count={unreadCount} onClick={openNotificationList} />
            {isOpen && <NotificationList setIsOpen={setIsOpen} setUnreadCount={setUnreadCount} />}
        </div>
    );
};
